import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mdl-update-status',
  imports: [],
  templateUrl: './mdl-update-status.html',
  styleUrl: './mdl-update-status.css'
})
export class MdlUpdateStatus {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public mdl: MatDialogRef<MdlUpdateStatus>,
  ) { }

  closeMdl(): void {
    this.mdl.close();
  }
}
